let CONTANT = "steam.valuation.dev.constant.";
if (process.env.NODE_ENV === "production") {
  CONTANT = "steam.valuation.constant.";
}

function buildStorageKey(key: string) {
  return CONTANT + key;
}

const constant = {
  token: buildStorageKey("token"),
  userInfo: buildStorageKey("userInfo"),
};

export { constant };
